import { render } from "./BrandDetail.vue?vue&type=template&id=4473e6c3&scoped=true&ts=true"
import script from "./BrandDetail.vue?vue&type=script&lang=ts"
export * from "./BrandDetail.vue?vue&type=script&lang=ts"

import "./BrandDetail.vue?vue&type=style&index=0&id=4473e6c3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4473e6c3"]])

export default __exports__